import React from "react";

type WarningIconProps = {
  fillBackground?: string;
  fillMarker?: string;
  height?: number;
  width?: number;
  className?: string;
};

export const WarningIcon: React.FC<WarningIconProps> = (props) => {
  const {
    fillMarker = "var(--surface-text-warning-light)",
    fillBackground = "none",
    height = 24,
    width = 24,
    className,
  } = props;

  return (
    <svg
      width={width}
      height={height}
      className={className}
      viewBox="0 0 24 24"
      fill={fillBackground}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.86572 20.5L12.0002 3L22.1347 20.5H1.86572ZM4.45022 19H19.5502L12.0002 6L4.45022 19ZM12.0002 17.8077C12.2291 17.8077 12.4209 17.7303 12.5757 17.5755C12.7306 17.4207 12.808 17.2288 12.808 17C12.808 16.7712 12.7306 16.5793 12.5757 16.4245C12.4209 16.2697 12.2291 16.1923 12.0002 16.1923C11.7714 16.1923 11.5796 16.2697 11.4247 16.4245C11.2699 16.5793 11.1925 16.7712 11.1925 17C11.1925 17.2288 11.2699 17.4207 11.4247 17.5755C11.5796 17.7303 11.7714 17.8077 12.0002 17.8077ZM11.2502 15.1923H12.7502V10.1923H11.2502V15.1923Z"
        fill={`${fillMarker}`}
      />
    </svg>
  );
};
